var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCliqCashWalletBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 584,
    height: 154,
    viewBox: "0 0 584 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M4.53 4.592C4.746 5.69 3.984 6.6 3.14 7.475 2.46 8.18 1.673 8.838.73 9.7c1.733-.544 3.05-1.138 4.518-1.542 2.086-.572 4.05-.492 5.972.248 1.312.503 2.526 1.096 3.698 1.728.454-.14-.046-.283.01-.423-.45-.523-.95-1.03-1.34-1.572-.664-.917-1.34-1.846-1.058-2.923.195-1.835 2.27-3.032 3.746-4.602-2.542.86-4.669 2.025-7.479 1.93-2.852-.098-4.725-1.488-7.123-2.49 1.207 1.56 2.781 2.84 2.856 4.537z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__e",
    d: "M5.705 2.772c-1.839.509-3.648.007-5.612-.145 1.467.74 3.04 1.231 3.859 2.284.636.648.57 1.373.437 2.091-.106.578-.302 1.15-.503 1.88.842-.687 1.398-1.324 2.14-1.87 1.052-.775 2.323-1.118 3.87-1.036 1.052.056 2.085.186 3.11.35.222-.177-.159-.168-.185-.268-.522-.239-1.067-.459-1.559-.72-.835-.446-1.681-.895-1.995-1.629-.712-1.193.05-2.36.264-3.64-1.207 1.047-2.014 2.204-3.826 2.703z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__a",
    width: 584,
    height: 154,
    x: 0,
    y: 0,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.581 -12.116)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.977,
    cy: 64.078,
    r: 7,
    fill: "#FFECF3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEF3",
    d: "M.186 111.226c56.653-2.72 107.519 23.688 84.039 39.545-30.135 20.353-58.661 18.945-18.449 25.092 13.018 1.99 24.889 11.192 29.125 22.76l-94.714.002z",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.581,
    cy: 144.116,
    r: 10,
    fill: "#C9D8F6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D8F6",
    d: "M584.788 114.82c-41.524-5.03-11.788-5.694 21.686-37.707C639.95 45.1 546.838-.304 470.982 47.518c-73.52 46.35-58.29 86.88-21.277 103.486 43.469 14.872-162.079 108.792 19.043 91.18 181.123-17.612 157.563-122.335 116.04-127.364z",
    opacity: 0.277
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E04278",
    fillOpacity: 0.25,
    d: "M317.007 19.31c3.299.892 6.818 1.093 8.692 3.192 1.449 1.208 1.338 3.067 1.083 4.953-.205 1.52-.614 3.08-1.018 5.041 1.833-2.274 3.037-4.234 4.652-6.088 2.3-2.635 5.106-4.327 8.546-5.135 2.342-.551 4.644-.903 6.93-1.164.482-.591-.362-.317-.426-.55-1.172-.257-2.395-.45-3.503-.784-1.877-.567-3.781-1.137-4.516-2.77-1.644-2.525-.012-5.947.394-9.298-2.627 3.419-4.362 6.846-8.357 9.286-4.06 2.48-8.105 2.41-12.477 3.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D8F6",
    d: "M238.076 68.37c1.068.798 2.242 1.346 2.775 2.441.432.68.308 1.416.135 2.143-.139.586-.349 1.162-.575 1.9.721-.675 1.217-1.306 1.846-1.84.895-.76 1.917-1.07 3.112-.94.813.088 1.603.25 2.385.449.189-.175-.107-.176-.118-.28-.383-.258-.785-.498-1.142-.78-.605-.477-1.22-.96-1.391-1.717-.436-1.237.271-2.401.563-3.7-1.042 1.031-1.784 2.185-3.24 2.64-1.481.463-2.838-.102-4.35-.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1744",
    d: "M305.696 97.33c.851.692 1.788 1.164 2.21 2.119.341.591.239 1.235.096 1.871-.114.513-.285 1.017-.47 1.663.581-.594.981-1.148 1.487-1.618.72-.667 1.54-.944 2.495-.837.651.073 1.283.211 1.907.38.152-.154-.085-.153-.093-.243-.305-.224-.626-.432-.91-.676-.482-.414-.97-.833-1.104-1.493-.343-1.078.23-2.1.47-3.236-.84.907-1.44 1.918-2.608 2.324-1.187.411-2.27-.074-3.48-.253z",
    opacity: 0.381
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1744",
    d: "M463.164 29.204c-2.034 1.645-4.448 1.773-6.908 2.496 2.097.392 4.219.364 5.653 1.535 1.045.658 1.263 1.768 1.4 2.901.11.912.105 1.858.165 3.042.742-1.43 1.158-2.647 1.835-3.817.963-1.664 2.373-2.788 4.294-3.413 1.308-.426 2.622-.732 3.94-.983.197-.371-.263-.173-.337-.31-.735-.103-1.492-.166-2.201-.319-1.202-.258-2.42-.518-3.107-1.459-1.363-1.433-.915-3.537-1.186-5.547-1.039 2.143-1.547 4.255-3.548 5.874z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1744",
    fillOpacity: 0.3,
    d: "M118.225 162.132c.709 3.115-1.987 5.438-3.587 8.251 3.319-1.639 5.852-3.618 9.87-4.061 2.552-.47 4.971.164 7.333.89 1.903.585 3.73 1.3 6.098 2.136-1.867-1.76-3.718-3.06-5.16-4.564-2.052-2.14-2.511-4.287-1.38-6.529.77-1.527 1.779-2.97 2.901-4.375-.482-.46-.658.112-1.011.078-1.098.601-2.145 1.251-3.305 1.791-1.967.915-3.956 1.844-6.619 1.77-4.439.18-7.972-1.816-12.2-3.08 2.889 2.572 6.362 4.629 7.06 7.693z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9D8F6",
    d: "M541.24 164.454c.87 3.074-1.7 5.535-3.15 8.428 3.228-1.81 5.654-3.92 9.644-4.572 2.523-.603 4.972-.096 7.369.505 1.931.484 3.793 1.103 6.2 1.814-1.956-1.66-3.872-2.86-5.391-4.288-2.16-2.03-2.732-4.15-1.719-6.448.688-1.565 1.62-3.058 2.668-4.521-.506-.435-.651.147-1.006.131-1.065.658-2.076 1.362-3.207 1.962-1.916 1.016-3.854 2.048-6.517 2.113-4.423.412-8.056-1.396-12.344-2.436 3.019 2.416 6.595 4.289 7.453 7.312z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.916 19.523)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.701 -6.98L26.584 5.691 7.048 17.102 -9.835 4.431z",
    mask: "url(#prefix__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(562.117 116.651)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0.88 -3.398L18.322 3.064 10.764 18.602 -6.678 12.141z",
    mask: "url(#prefix__f)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliqCashWalletBg);
export default __webpack_public_path__ + "static/media/cliqCashWalletBg.9d04fa2844c1bbeb5893205050ae6522.svg";
export { ForwardRef as ReactComponent };